import { render, staticRenderFns } from "./CityGoods.vue?vue&type=template&id=3cdc0fe4&scoped=true&lang=pug&"
import script from "./CityGoods.vue?vue&type=script&lang=ts&"
export * from "./CityGoods.vue?vue&type=script&lang=ts&"
import style0 from "./CityGoods.vue?vue&type=style&index=0&id=3cdc0fe4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc0fe4",
  null
  
)

export default component.exports